/* eslint-disable import/prefer-default-export */
export const PARTIAL_SIGN_UP_PHASES = {
  ACCOUNT: 'account',
  PHONE_NUMBER: 'phone_number',
  PERSONAL_INFO: 'personal_information',
  ADDITIONAL_DETAILS: 'additional_details',
  ADDRESS: 'physical_address',
  MAILING_ADDRESS: 'mailing_address',
};

export const onboardingScreens = {
  SIGNUP: 'signup',
  CONFIRM_EMAIL: 'confirm_email',
  ADD_PHONE_NUMBER: 'add_phone_number',
  CONFIRM_PHONE_NUMBER: 'confirm_phone_number',
  ADD_PERSONAL_INFO: 'add_personal_info',
  ADDITIONAL_PERSONAL_DETAILS: 'additional_personal_details',
  ADD_PHYSICAL_ADDRESS: 'add_physical_address',
  ADD_MAILING_ADDRESS: 'add_mailing_address',

  LOGIN: 'login',
  TFA: 'tfa',

  RESET_PASSWORD_REQUEST: 'reset_password_request',
  CONFIRM_RESET_PASSWORD_EMAIL: 'confirm_reset_password_email',
  CREATE_NEW_PASSWORD: 'create_new_password',
};

export const RECAPTCHA_EVENTS = {
  SIGNUP_VERIFY_EMAIL: 'signup_verify_email',
  RESET_PASSWORD_VERIFY_EMAIL: 'reset_password_verify_email',
  SIGNUP_CREATE_USER: 'signup_create_user',
  SIGNUP_VERIFY_PHONE_NUMBER: 'signup_verify_phone_number',
  SIGNUP_CHECK_PHONE_NUMBER: 'signup_check_phone_number',
  VERIFY_PHONE_NUMBER: 'verify_phone_number',
  LOGIN: 'login',
  WHITELIST_AUTH_EMAIL: 'whitelist_auth_email',
};

export const SIGNUP_STEPS_COUNT = 5;

export const DEFAULT_COUNTRY_CODE = '44';
export const DEFAULT_COUNTRY_CODE_ALPHA2 = 'GB';

export const US_COUNTRY_ALPHA = 'USA';
export const CANADA_COUNTRY_ALPHA = 'CAN';
